import httpInstances from '@/api/axiosInstance';

type DatalakeByIdParams = { fileId: string };
type DatalakeByNameParams = { fileName: string; groupName: string };

export async function fetchDatalakeFile(
  params: DatalakeByIdParams,
  responseType?: 'blob'
): Promise<{ data: Blob; status: number }>;
export async function fetchDatalakeFile(
  params: DatalakeByNameParams,
  responseType: 'text'
): Promise<string>;
export async function fetchDatalakeFile(
  params: DatalakeByNameParams,
  responseType?: undefined
): Promise<unknown>;
export async function fetchDatalakeFile(
  params: DatalakeByIdParams | DatalakeByNameParams,
  responseType?: 'blob' | 'text'
): Promise<unknown> {
  const url =
    'fileId' in params
      ? `/proxy/datalake/file/${params.fileId}`
      : `/proxy/datalake/file?fileName=${encodeURIComponent(params.fileName)}&groupName=${encodeURIComponent(params.groupName)}`;

  const response = await httpInstances.axiosInternalInstance.get(url, {
    ...(responseType && { responseType })
  });

  if (response.status !== 200) {
    throw new Error('File not found');
  }

  if ('fileId' in params) {
    return response;
  }

  if (responseType === 'text') {
    return typeof response.data === 'string' ? response.data : String(response.data);
  }

  return response.data;
}
